// Polyfill
import '@babel/polyfill'

import '../assets'

import Vue from 'vue'
import VueBootstrapper from 'vue-bootstrapper'
import Vuelidate from 'vuelidate'

import FormView from '@components/form_view'
import ExpiredView from '@components/expired_view'


Vue.use(Vuelidate)

const vueInstance = new Vue({
  el: '#form-root',
  data () {
    return {
      // windowWidth: 0,
      // windowHeight: 0,
      // routes: [],
    }
  },
  components:{
    FormView,
    ExpiredView
  },
  created () {
  },
  props: {
  },
  mounted () {
  },
  methods: {
  },
})
